import { render } from "./Detail404.vue?vue&type=template&id=666846ac&scoped=true"
import script from "./Detail404.vue?vue&type=script&lang=js"
export * from "./Detail404.vue?vue&type=script&lang=js"

import "./Detail404.vue?vue&type=style&index=0&id=666846ac&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666846ac"]])

export default __exports__